<ub-heading i18n>Communication language</ub-heading>
<p>{{ preferredLanguage?.languageName }}</p>
<button mat-flat-button color="accent" type="button" (click)="changeLanguage()" [disabled]="!canEditPreferredLanguage" i18n>Change language</button>
